module.exports = __webpack_public_path__ + "media/images/corporate-sales/icons/design-70b173c523a157391d3ab4a1a14b1e38.svg";